/**
 * Safe localStorage wrapper for environments where localStorage may be null
 * (iOS Safari private browsing, WKWebView with storage restrictions, etc.)
 */

function isLocalStorageAvailable(): boolean {
    try {
        const test = "__storage_test__";
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
        return true;
    } catch {
        return false;
    }
}

const storageAvailable = typeof window !== "undefined" && isLocalStorageAvailable();

export function safeGetItem(key: string): string | null {
    if (!storageAvailable) {
        return null;
    }
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
}

export function safeSetItem(key: string, value: string): boolean {
    if (!storageAvailable) {
        return false;
    }
    try {
        localStorage.setItem(key, value);
        return true;
    } catch {
        return false;
    }
}

export function safeRemoveItem(key: string): boolean {
    if (!storageAvailable) {
        return false;
    }
    try {
        localStorage.removeItem(key);
        return true;
    } catch {
        return false;
    }
}

export const isStorageAvailable = storageAvailable;
